import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../Layout/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import axios from "axios";
import SendIcon from "@mui/icons-material/Send";
import TextAliginment from "../Layout/TextAliginment";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import profile from "../../assets/img/user.png";
import botgif from "../../assets/img/Aays.png";
import CheckIcon from "@mui/icons-material/Check";
import Alert from "@mui/material/Alert";
import { v4 as uuidv4 } from "uuid";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw"; // Import plugin for rendering raw HTML
import $ from "jquery";
import DefaultMessageScreen from "../Layout/Home/DefaultMessageScreen";
import History from "../Layout/History/History";
import LoadingMessage from "../Layout/LoadingMessage";
import FeedbackModel from "../Layout/Home/FeedbackModel";
import DeleteModel from "../Layout/Home/DeleteModel";
import PdfViewModal from "../Layout/Home/PdfViewModal";
import PlotlyGraph from "../Layout/Plotly/PlotlyGraph";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import Login from "../auth/Login";
import { getToken, loginRequest } from "../auth/authConfig";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



const buttonStyle = (isDisabled) => ({
  padding: "10px 20px",
  fontSize: "16px",
  fontWeight: "bold",
  color: isDisabled ? "#ccc" : "#fff", // Grey color for disabled state
  backgroundColor: isDisabled ? "#f0f0f0" : "#0000a0", // Light grey background for disabled state
  border: "none",
  borderRadius: "5px",
  cursor: isDisabled ? "not-allowed" : "pointer", // Change cursor for disabled state
  boxShadow: isDisabled ? "none" : "0px 4px 6px rgba(0, 0, 0, 0.1)", // Remove shadow for disabled state
  width: "auto",
});

//
const tooltipStyle = `
  .tooltip {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 220px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 125%; /* Position above the text */
    left: 50%;
    margin-left: -110px;
    opacity: 0;
    transition: opacity 0.3s;
  }
  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
`;



let comName; // company name that will come from the backend.

const rearrangeReferences = (inputText) => {
  const updatedText = inputText.replace(
    /<reference>([\s\S]*?)<\/reference>/g,
    (_, ref) => {
      if (ref.startsWith("http")) {
        // If the reference starts with "http", return it as a hyperlink
        return `<a href="${ref}" target="_blank" rel="noopener noreferrer" class="pdf-link">[Link]</a>`;
      } else {
        // Handle escaped backslashes and brackets in references
        const cleanedRef = ref.replace(/\\{2}/g, "\\").replace(/\\"/g, '"');
        const matches = [
          ...cleanedRef.matchAll(/"([^"]+)", pages? ([\d, ]+)/g),
        ];
        return matches
          .map(([_, doc, pages]) => {
            // Handle multiple pages (e.g., "1, 5")
            return pages
              .split(",")
              .map(
                (page) =>
                  `<span className="tooltip">[${page.trim()}]<span className="tooltiptext">${doc} in Page ${page.trim()}</span></span>`
              )
              .join(", ");
          })
          .join(", ");
      }
    }
  );

  return updatedText.trim();
};

export default function GenerateSummary() {
  const [userInput, setUserInput] = useState("");
  const [newMessage, setnewMessage] = useState(true);
  const [chatSessions, setChatSessions] = useState([]);
  const [messages, setMessages] = useState([]);
  const [isNewSession, setIsNewSession] = useState(true);
  const [lastMessageData, setLastMessageData] = useState({});
  const [isPageDirty, setIsPageDirty] = useState(false);
  const chatWindowRef = useRef(null);
  const [tabValue, setTabValue] = useState("sales_finance_office");
  const [modelName, setModelName] = useState("gpt-4o");
  const [open, setOpen] = useState(false);
  const [isdeletePopup, setisdeletePopup] = useState(false);
  const [Feedback, setFeedback] = useState("");
  const [ResponceText, setResponceText] = useState("");
  const [ResponceId, setResponceId] = useState();
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [loadingResponce, setloadingResponce] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [getsessionData, setgetsessionData] = useState([]);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);
  const [CommentData, setCommentData] = useState("");
  const [getsessionidpost, setsessionidpost] = useState(null);
  const [diableChats, setdiableChats] = useState(false);
  const [pushData, setpushData] = useState([]);
  const [QuestionData, setQuestion] = useState("");
  const [messageuniqueId, setmessageuniqueId] = useState("");
  const [isfatching, setisfatching] = useState(true);
  const [isLoadingMessage, setisLoadingMessage] = useState(false);
  const [filteredToday, setfilteredToday] = useState([]);
  const [filteredyesteday, setfilteredyesteday] = useState([]);
  const [filteredLastweek, setfilteredLastweek] = useState([]);
  const [filteredLastMonth, setfilteredLastMonth] = useState([]);
  const [SessionIdData, setSessionIdData] = useState();
  const [isdeleteLoading, setisdeleteLoading] = useState(false);
  const [isnewTicket, setisnewTicket] = useState(false);
  const [snowTicket, setsnowTicket] = useState("");
  const [SavesnowTicket, setSavesnowTicket] = useState(uuidv4());
  const [sessionStart, setsessionStart] = useState(true);
  const [isDefaultPage, setisDefaultPage] = useState(true);
  const [isNewchatbtn, setisNewchatbtn] = useState(false);
  const [userEmail, setUserEmail] = useState(localStorage.getItem("email"));
  const [filterbyHistoryList, setfilterbyHistoryList] = useState([]);
  const [isalert, setisalert] = useState(false);
  const [errorType, seterrorType] = useState("error");
  const markdownRef = useRef(null);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [isPdfView, setIsPdfView] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const [errorMessage, seterrorMessage] = useState(
    "Something went wrong, please try again later"
  );
  const [uuidInfo, setuuid] = useState(uuidv4());
  const handleInputChange = (e) => {
    setUserInput(e.target.value);
    setIsPageDirty(true);
  };

  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [summaryView, setSummaryView] = useState(false);
  const [sessionDataID,setsessionDataID] = useState ("")

  function generateUniqueId() {
    const timestamp = Date.now().toString(36); // Convert timestamp to base 36
    const randomString = Math.random().toString(36).substr(2, 5); // Generate a random string
    return timestamp + "-" + randomString; // Concatenate timestamp and random string
  }
  const uniqueId = generateUniqueId();
  // const inputId = uuidv4();

  const handlePdfView = (event) => {
    // alert("called")
    if (event.target.classList.contains("pdf-link")) {
      event.preventDefault();
      setIsPdfView(true);
      const hrefValue = event.target.getAttribute("href");
      if (hrefValue) {
        setPdfUrl(hrefValue);
      }
    }
  };

  const handleFollowupKeyDown = (e) => {
    if (e.key === "Enter") {
      if (userInput) {
        handleSendMessage("summary", "followup");
      } else {
        return false;
      }
    }
  };

  const [currentSessionId, setCurrentSessionId] = useState(null);

  // Save sessions in localStorage
const saveSessionsToLocalStorage = (sessions) => {
  localStorage.setItem("chatSessions", JSON.stringify(sessions));
};

const createReport = async (reportPayload) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/history`, // replace with your backend URL
      reportPayload,
      {
        headers: {
          "Content-Type": "application/json",
          "oidc-token": token,

        },
      }
    );

     if(response.status === 200){
       setsessionDataID(response.data.session_id)
       loadSessions()
       return response.data;

     }
    // Returns the backend response
  } catch (error) {
    console.error("Error creating report:", error.response?.data || error.message);
    throw error;
  }
};
// Load sessions from localStorage
const loadSessionsFromLocalStorage = () => {
  const data = localStorage.getItem("chatSessions");
  return data ? JSON.parse(data) : [];
};

  const summaryUserInput = `Generate Summary of ${selectedCompany} of year ${selectedYear} and quarter ${selectedQuarter}`;

  const handleSendMessage = async (value, follow) => {

    let requestedInput;
    let followup = false;

    if (value === "summary") {
      requestedInput = summaryUserInput;
      setSummaryLoading(true);
      setSummaryView(true);
    } else {
      return false;
    }

    if (follow === "followup") {
      followup = true;
      requestedInput = userInput;
    }

    setUserInput("");
    const newMessage = { user: true, text: requestedInput };
    const typingMessage = {
      user: false,
      text: "Typing...",
      link: null,
      uiid: uniqueId,
      type: "bot",
      question: requestedInput,
      feedback: null,
      plotData: [],

    };
    setnewMessage(false);
    setloadingResponce(true);

    console.log("messsageesss", messages);

    try {
      setMessages((prevMessages) => [
        ...prevMessages,
        newMessage,
        typingMessage,
      ]);

      const baseurl = `${process.env.REACT_APP_DE_AI_BASE_URL}`;



      const SummaryRequestedBody = {
        category: followup ? "chat" : "summarize",
        query: requestedInput.toLowerCase(),
        tone: tabValue,
        model: modelName,
        company_name: selectedCompany,
        year: selectedYear,
        quarter: selectedQuarter,
        follow_up_question: followup ? "True" : "False",
        history: followup ? pushData : [],
      };

      const summaryFollowUpBody = {
        category: followup ? "chat" : "summarize",
        query: requestedInput.toLowerCase(),
        tone: tabValue,
        model: modelName,
        company_name: comName ? comName : "",
        year: selectedYear,
        quarter: selectedQuarter,
        follow_up_question: followup ? "True" : "False",
        history: followup ? pushData : [],
      };

      const requestedBody = followup ? summaryFollowUpBody : SummaryRequestedBody;
      // const requestBody =
      //   value === "question" ? chatRequestedBody : SummaryRequestedBody;

      const response = await axios.post(baseurl, requestedBody);

      if (response.status === 200) {
        const botResponse = response.data.response;
        const plotData = response.data.tables;

        const reportPayload = {
          Questions:summaryUserInput,
          session_id: sessionDataID || "",
          history:response.data,
          report_type:"summary"
        }

        createReport(reportPayload)
  

        const companyNameResponse = response.data.company_name;
        comName = companyNameResponse;
        setloadingResponce(false);
        setSummaryLoading(false);
        setMessages((prevMessages) =>
          prevMessages.filter((msg) => msg !== typingMessage)
        );

        // console.log("printing userInput", userInput)

        if (isNewSession) {
          const newChatSession = {
            id: chatSessions.length + 1,
            history: [
              { user: true, text: requestedInput, plotData: [] },
              { user: false, text: botResponse, plotData: plotData },
            ],
            lastMessage: { user: true, text: requestedInput },
            endpoint: tabValue,
            createdAt: new Date() 

          };

          setChatSessions((prevSessions) => {
            const updated = [...prevSessions, newChatSession];
            saveSessionsToLocalStorage(updated);
            return updated;
          });
          // array of queestion and bot answer (res)
          const res = [
            { user: true, text: requestedInput },
            {
              user: false,
              text: botResponse,
              questions: requestedInput,
              feedback: 0,
              plotData: plotData,

            },
          ];

          pushData.push(
            ...res.map((item) => ({
              user: item.user,
              text: item.text,
              question: item.questions,
              feedback: 0,
              uiid: item.report_id,
              plotData: item.plotData || [],

            }))
          );
          setIsNewSession(false);

     
        } else {

          const res = [
            { user: true, text: requestedInput },
            {
              user: false,
              text: botResponse,
              questions: requestedInput,
              feedback: 0,
              plotData: plotData,
            },
          ];

          setChatSessions((prevSessions) => {
            const updated = prevSessions.map((session) =>
              session.id === currentSessionId
                ? {
                    ...session,
                    history: [...session.history, ...res],
                    lastMessage: { user: false, text: botResponse },
                    endpoint: tabValue,
                  }
                : session
            );
            saveSessionsToLocalStorage(updated);
            return updated;
          });

       
          pushData.push(
            ...res.map((item) => ({
              user: item.user,
              text: item.text,
              question: item.questions,
              feedback: 0,
              iid: item.report_id,
              plotData: item.plotData || [],

            }))
          );

          // postAPIHistory(pushData, botResponse, tabValue, requestedInput);
        }

        if (typingMessage.text === "Typing...") {
          typingMessage.text = "";
        }

        setMessages((prevMessages) => [...prevMessages, typingMessage]);

        if (typingMessage.text === "") {
          typingMessage.text = "Typing...";
        }

        setTimeout(() => {
          typingMessage.text = "";
          let text = botResponse;
          typingMessage.text += text;
          typingMessage.plotData = plotData;

          setMessages((prevMessages) => [...prevMessages]);

          // typeWriter();

          if (botResponse.link !== null) {
            typingMessage.link = botResponse.link;
          }
        }, 1000);
      }

      if (response.status === 502) {
        if (typingMessage.text === "Typing...") {
          typingMessage.text =
            "there is some issue in service, please retry again";
        }
        setMessages((prevMessages) => [...prevMessages]);
        setloadingResponce(false);
        if (isNewSession) {
          setIsNewSession(true);
        } else {
          setIsNewSession(false);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (typingMessage.text === "Typing...") {
        typingMessage.text = "network error";
      }
      setMessages((prevMessages) => [...prevMessages]);
      setloadingResponce(false);
      if (isNewSession) {
        setIsNewSession(true);
      } else {
        setIsNewSession(false);
      }
    } finally {
      setUserInput("");
    }
  };

  const handleExampleClick = (exampleText) => {
    setUserInput(exampleText);
  };

  const handleInputKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (loadingResponce) {
        setisalert(true);
        seterrorType("error");
        seterrorMessage("Please wait, There is a ongoing process");

        setTimeout(() => {
          setisalert(false);
        }, 3000);
        return false;
      } else {
        handleSendMessage();
      }
    }
  };

  const handleBeforeUnload = (event) => {
    if (isPageDirty) {
      const message =
        "You have unsaved changes. Are you sure you want to leave?";
      event.returnValue = message; // Standard for most browsers
      return message; // For some older browsers
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isPageDirty]);

  useEffect(() => {
    if (messages.length > 0) {
      // chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  }, [messages, chatSessions, isNewSession]);

  useEffect(() => {
    if (messages.length > 0) {
      setLastMessageData(messages[messages.length - 2]);
    }
  }, [messages]);

  const handleRadioChange = (event) => {
    setTabValue(event.target.value);
    setUserInput("");
  };
  const handleModelChange = (event) => {
    setModelName(event.target.value);
    setUserInput("");
  };

  const questionTAB = [
    {
      text: "What is organic net growth of Mondelez?",
    },
    {
      text: "What is SkinnyPop's growth for Hershey? ",
    },
    {
      text: "What is Petcare Margin growth of Nestle?",
    },
  ];

  const feedbackAction = (id, message, feedback, question) => {
    setOpen(!open);
    setFeedback(feedback);
    setResponceText(message);
    setResponceId(id);
    setQuestion(question);
    setmessageuniqueId(id);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // console.log(form);
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (selectedOptions.length > 0) {
        setValidated(true);
        setIsloading(true);

        const data = {
          responseId: messageuniqueId,
          feedback: Feedback === "good" ? 1 : 0,
          responseText: ResponceText,
          question: QuestionData === undefined ? "" : QuestionData,
          email: userEmail,
          commentText:
            CommentData + ", Additional comments are: " + selectedOptions,
        };
        const url = `${process.env.REACT_APP_BASE_URL}/feedback`;
        const token = await getToken();

        axios
          .post(url, data, {
            headers: {
              "Content-Type": "application/json",
              "oidc-token": token,
    
            }
          })

          .then(function (response) {
            if (response.status === 200) {
              // console.log(response);
              setIsloading(false);
              setValidated(false);
              setSelectedOptions([]);
              setCommentData("");
              setsuccess(true);
              setOpen(!open);
              setTimeout(() => {
                setsuccess(false);
              }, 3000);

              if (Feedback === "good") {
                $(`#like_${messageuniqueId}`).addClass("goodfeedback");
                $(`#dislike_${messageuniqueId}`).removeClass("badFeedback");
              } else {
                $(`#dislike_${messageuniqueId}`).addClass("badFeedback");
                $(`#like_${messageuniqueId}`).removeClass("goodfeedback");
              } // id={`like_${message.id}`}

              seterror(false);
            }
          })
          .catch(function (error) {
            console.log(error);
            setIsloading(false);
            setValidated(false);
            setsuccess(false);
            seterror(true);
          });
      } else {
        seterror(true);
      }
    }
  };

 
  const { accounts, instance } = useMsal();
  const account = accounts?.[0];
  const [profileImage, setProfileImage] = useState(null);

  const getProfilePhoto = async () => {
    try {
      // Ensure you acquire a token for the signed-in user
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0], // Use the first account from the authenticated accounts
      });

      const token = response.accessToken;

      console.log(token)

      // Fetch the profile photo
      const photoResponse = await axios.get(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
          },
          responseType: "arraybuffer", // To receive the image as binary data
        }
      );

      const blob = new Blob([photoResponse.data], { type: "image/jpeg" });
      const imageUrl = URL.createObjectURL(blob);
      setProfileImage(imageUrl);
    } catch (err) {
      console.error("Error fetching profile photo", err);
    }
  };

  useEffect(() => {
    getProfilePhoto();
  }, []);


  useEffect(() => {
    // Save the profile image to localStorage whenever it changes
    localStorage.setItem("profileImage", profileImage);
  }, [profileImage]);

  const newChatStart = () => {
    const newUUID = uuidv4();
    setuuid(newUUID);
    setisDefaultPage(false);
    setnewMessage(true);
    setMessages([]);
    setTabValue("sales_finance_office");
    setsessionidpost(null);
    setdiableChats(false);
    setpushData([]);
    setsessionStart(true);
    setSavesnowTicket("");
    setsnowTicket("");
    setSummaryView(false);
    setsessionDataID("")
    // setisnewTicket(true)

    // $(`.recent_history_item`).css({
    //   background: "#fff",
    //   color: "#3d3d3d",
    //   border: "none",
    //   "box-shadow": "none",
    // });
    // $(`.recent_history_item svg`).css({
    //   color: "#3d3d3d",
    // });
    // $(`.recent_history_item .trashIconnew`).css({
    //   color: "#999",
    // });
  };

  const handleButtonClick = (option) => {
    // Toggle the selection status of the clicked option
    seterror(false);
    const isSelected = selectedOptions.includes(option);
    const newSelectedOptions = isSelected
      ? selectedOptions.filter((selectedOption) => selectedOption !== option)
      : [...selectedOptions, option];

    // Update the state with the new selected options
    setSelectedOptions(newSelectedOptions);
  };

  const handleclose = () => {
    setOpen(false);
    setSelectedOptions([]);
    setCommentData("");
    setsuccess(false);
    seterror(false);
  };


  const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds

  const fetchHistory = async () => {
    try {
      const token = await getToken();
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/saveHistory?report_type=summary`,{
        headers: {
          "Content-Type": "application/json",
          "oidc-token": token,

        },
      }); // Adjust the endpoint as per your Flask API

      if(response.status === 200){
        setisfatching(false);
        return response.data; // Should be an array of session objects

      }
    } catch (error) {
      console.error("Error fetching session history:", error);
      return [];
    }
  };

  const loadSessions = async () => {
    setisfatching(true);
    const savedSessions = await fetchHistory();
    // setChatSessions(savedSessions);
   

    const currentDate = new Date();
    const oneDay = 24 * 60 * 60 * 1000;

    const sessionsWithDates = savedSessions.map((item) => ({
      ...item,
      createdAtDate: new Date(item.createdAt || Date.now())
    }));

    // Today
    const todayData = sessionsWithDates.filter(
      (item) => item.createdAtDate.toDateString() === currentDate.toDateString()
    );
    // console.log(todayData)
    setfilteredToday(todayData);

    // Yesterday
    const yesterdayData = sessionsWithDates.filter(
      (item) =>
        item.createdAtDate.toDateString() ===
        new Date(currentDate - oneDay).toDateString()
    );
    setfilteredyesteday(yesterdayData);

    // Last 7 days excluding today and yesterday
    const last7DaysData = sessionsWithDates.filter(
      (item) =>
        item.createdAtDate >= new Date(currentDate - 7 * oneDay) &&
        item.createdAtDate <= currentDate &&
        !todayData.some((todayItem) => todayItem.session_id === item.session_id) &&
        !yesterdayData.some((yesterdayItem) => yesterdayItem.session_id === item.session_id)
    );
    setfilteredLastweek(last7DaysData);

    // Last 30 days excluding today, yesterday, and last 7 days
    const last30DaysData = sessionsWithDates.filter(
      (item) =>
        item.createdAtDate >= new Date(currentDate - 30 * oneDay) &&
        item.createdAtDate <= currentDate &&
        !todayData.some((todayItem) => todayItem.session_id === item.session_id) &&
        !yesterdayData.some((yesterdayItem) => yesterdayItem.session_id === item.session_id) &&
        !last7DaysData.some((prev7DaysItem) => prev7DaysItem.session_id === item.session_id)
    );
    setfilteredLastMonth(last30DaysData);
  };


  useEffect(() => {
    loadSessions()
  }, []);

  useEffect(() => {
    console.log("data refresh")
    },[filteredToday,filteredyesteday,filteredLastweek,filteredLastMonth])
  
  
  
  
  const messageClick = async (id) => {
    setdiableChats(true);
    setisLoadingMessage(true);
    setisDefaultPage(false);
  
    // Reset UI styles
    document.querySelectorAll('.recent_history_item').forEach(item => {
      item.style.cssText = `
        background: #fff;
        color: #3d3d3d;
        border: none;
        box-shadow: none;
      `;
    });
  
    document.querySelectorAll('.recent_history_item svg').forEach(svg => {
      svg.style.color = '#3d3d3d';
    });
  
    document.querySelectorAll('.recent_history_item .trashIconnew').forEach(icon => {
      icon.style.color = '#999';
    });
  
    // Highlight selected item
    const selectedItem = document.querySelector(`#history_${id} .recent_history_item`);
    if (selectedItem) {
      selectedItem.style.cssText = `
        color: #bb1ccc;
        border: 1px solid #bb1ccc;
        box-shadow: inset 4px 0 0 0 #bb1ccc;
      `;
      const svgs = selectedItem.querySelectorAll('svg');
      svgs.forEach(svg => {
        svg.style.color = '#bb1ccc';
      });
    }
  
    try {
      // Fetch session from API
      const token = await getToken();
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/sessionHistory/${id}`,{
        headers: {
          "Content-Type": "application/json",
          "oidc-token": token,

        }
      });
      const selectedSession = response.data;
  
      if (selectedSession && selectedSession.length > 0) {
        setMessages(selectedSession);
        setCurrentSessionId(id);
  
        // Map pushData for follow-up questions
        const mappedHistory = selectedSession.map(item => ({
          user: item.user,
          text: item.text,
          question: item.questions || item.question,
          feedback: item.feedback || 0,
          uiid: item.uiid || generateUniqueId(),
          plotData: item.plotData || [],
        }));
  
        setpushData(mappedHistory);
  
        setisLoadingMessage(false);
        setnewMessage(false);
        setIsNewSession(false);
      } else {
        setMessages([]);
        setisLoadingMessage(false);
        console.warn(`Session with ID ${id} returned empty from API`);
      }
    } catch (err) {
      console.error("Error fetching session from API:", err);
      setMessages([]);
      setisLoadingMessage(false);
    }
  };


 

  const handleDeletePopup = (id) => {
    console.log("id",id)
    setSessionIdData(id);
    setisdeletePopup(!isdeletePopup);
  };


  const handleDelete = async (sessionId) => {
    // alert(sessionId)
    if (!sessionId) return;
  
    setisdeleteLoading(true);
  
    try {
      // Delete from localStorage first
      const savedSessions = loadSessionsFromLocalStorage();
      const updatedSessions = savedSessions.filter(
        (session) => session.id !== sessionId
      );
      saveSessionsToLocalStorage(updatedSessions);
  
      // Update frontend state
      setChatSessions(updatedSessions);
      setgetsessionData(updatedSessions);
      setisdeleteLoading(false);
      setisdeletePopup(false);
      setSessionIdData();
      setisDefaultPage(false);
      setnewMessage(true);
      setMessages([]);
      setTabValue("sales_finance_office");
      setsessionidpost(null);
      setdiableChats(false);
      setpushData([]);
      setsessionStart(true);
      setSavesnowTicket("");
      setsnowTicket("");
      setIsNewSession(true);
      setCurrentSessionId(null);
  
      // Reset UI styles
      document.querySelectorAll(".recent_history_item").forEach((item) => {
        item.style.cssText = `
          background: #fff;
          color: #3d3d3d;
          border: none;
          box-shadow: none;
        `;
      });
  
      document.querySelectorAll(".recent_history_item svg").forEach((svg) => {
        svg.style.color = "#3d3d3d";
      });
  
      document
        .querySelectorAll(".recent_history_item .trashIconnew")
        .forEach((icon) => {
          icon.style.color = "#999";
        });
  
      // Call backend API to delete session
      const token = await getToken();
      const deleteUrl = `${process.env.REACT_APP_BASE_URL}/api/session/delete/${sessionId}`;
      const response = await axios.delete(deleteUrl,{
        headers: {
          "Content-Type": "application/json",
          "oidc-token": token,

        }
      });
  
      if (response.data.success) {
        console.log(`Session ${sessionId} deleted from backend successfully.`);
        loadSessions()
      } else {
        console.warn("Backend deletion failed:", response.data.error);
      }
  
    } catch (error) {
      console.error("Error deleting session:", error);
      setisdeleteLoading(false);
      setSessionIdData();
    }
  };

  const handleCopyClick = ({ index }) => {
    const contentId = `message-copied_${index}`;
    const element = document.getElementById(contentId);

    if (element) {
      const textToCopy = element.innerText; // Get the plain text content of the element
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          // Optionally, you can show a confirmation message here.
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };

  console.log(messages)
  return (
    <>
    <AuthenticatedTemplate>
      <div id="homePage" style={{ overflow: "hidden", position: "relative" }}>
        <Box className="mainLayout" sx={{ display: "flex", overflow: "hidden" }}>
          <MainLayout />

          <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
            <DrawerHeader />
            <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

            <div id="mainHome">
              <div id="mainChatContent">
                {/* // History section starts  */}

                <div>
                  <History
                    isNewchatbtn={isNewchatbtn}
                    newChatStart={newChatStart}
                    isfatching={isfatching}
                    filteredToday={filteredToday}
                    messageClick={messageClick}
                    handleDeletePopup={handleDeletePopup}
                    filteredyesteday={filteredyesteday}
                    oneDay={oneDay}
                    filteredLastweek={filteredLastweek}
                    filteredLastMonth={filteredLastMonth}
                  />
                </div>

                {/* // History section ends  */}

                <>
                  {isLoadingMessage ? (
                    <>
                      <LoadingMessage />
                    </>
                  ) : (
                    <>
                      <>
                        <div
                          id="textbodyarea"
                          className="card chatting-box mb-0"
                          style={{
                            display: "block",
                            width: "100%",
                            textAlign: "left",
                          }}
                          ref={chatWindowRef}
                        >
                          <>
                            <div
                              style={{ minHeight: "100px" }}
                              className="card-body"
                            >
                              <div
                                style={{
                                  height: "auto",
                                  width: "100%",
                                  display: "grid",
                                  gridGap: "10px",
                                  color: "#3d3d3d",
                                }}
                              >
                                <div className="chat-messages">
                                  {newMessage && (
                                    <>
                                      <DefaultMessageScreen
                                        selectedCompany={selectedCompany}
                                        setSelectedCompany={setSelectedCompany}
                                        selectedYear={selectedYear}
                                        setSelectedYear={setSelectedYear}
                                        selectedQuarter={selectedQuarter}
                                        setSelectedQuarter={setSelectedQuarter}
                                        summaryLoading={summaryLoading}
                                        buttonStyle={buttonStyle}
                                        handleSendMessage={handleSendMessage}
                                        tabValue={tabValue}
                                        handleRadioChange={handleRadioChange}
                                        modelName={modelName}
                                        handleModelChange={handleModelChange}
                                        questionTAB={questionTAB}
                                        handleExampleClick={handleExampleClick}
                                      />
                                    </>
                                  )}

                                  {!newMessage && (
                                    <div
                                      style={{
                                        position: "relative",
                                        display: "grid",
                                        gap: "1rem",
                                      }}
                                    >
                                      {messages?.map((message, index) => (
                                        <div key={index}>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              alignContent: "baseline",
                                              alignItems: "baseline",
                                            }}
                                          >
                                            {message.user === false ? (
                                              <>
                                                <div
                                                  style={{ paddingTop: "5px" }}
                                                >
                                                  <img
                                                    style={{
                                                      margin: "auto",
                                                      borderRadius: "100%",
                                                      width: "30px",
                                                      height: "30px",
                                                    }}
                                                    src={botgif}
                                                    alt="Profile"
                                                  />
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                <div
                                                  style={{ paddingTop: "5px" }}
                                                >
                                                  <img
                                                    style={{
                                                      margin: "auto",
                                                      borderRadius: "100%",
                                                      width: "30px",
                                                      height: "30px",
                                                      background: "#eee",
                                                    }}
                                                    src={profileImage || profile}
                                                    alt="Profile"
                                                  />
                                                </div>
                                              </>
                                            )}

                                            <div
                                              key={index}
                                              id={`message_${
                                                message.user ? "user" : "bot"
                                              }_${index}`}
                                              className={`message ${
                                                message.user ? "user" : "bot"
                                              }`}
                                            >
                                              {message.text === "Typing..." ? (
                                                <div className="outer-div">
                                                  <div
                                                    style={{ width: "50px" }}
                                                    id="demo"
                                                  ></div>
                                                  <div className="typing">
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                  </div>
                                                </div>
                                              ) : (
                                                <>
                                                  {message.text ===
                                                  "network error" ? (
                                                    <>
                                                      <TextAliginment
                                                        error="error"
                                                        text="We're sorry, but it seems there's a problem connecting to the server. Please check your internet connection and try again. If the issue persists, contact our support team for assistance."
                                                      />
                                                    </>
                                                  ) : (
                                                    // <TextAliginment
                                                    //   text={message.text}
                                                    // />

                                                    // <ReactMarkdown>
                                                    //   {message.text}
                                                    // </ReactMarkdown>
                                                    <>
                                                      <style>
                                                        {tooltipStyle}
                                                      </style>
                                                      <div
                                                        onClick={handlePdfView}
                                                        id={`message-copied_${index}`}
                                                        ref={markdownRef}
                                                      >
                                                          <ReactMarkdown
                                                            remarkPlugins={[
                                                              remarkGfm,
                                                            ]}
                                                            rehypePlugins={[
                                                              rehypeRaw,
                                                            ]} // Allow raw HTML to be rendered
                                                          >
                                                            {rearrangeReferences(
                                                              message.text
                                                            )}
                                                          </ReactMarkdown>
                                                          {/* {message.plotData} */}

                                                          {/* {message && message.plotData && message.plotData.length > 0 && (
                                                            <>
                                                              <PlotlyGraph plotData={message.plotData} rearrangeReferences={rearrangeReferences} />
                                                            </>
                                                          )} */}
                                                      </div>
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </div>
                                          </div>

                                          {message.user === false &&
                                            message.text !== "Typing..." &&
                                            message.text !== "network error" && (
                                              <div
                                                style={{
                                                  display: "grid",
                                                  justifyContent: "flex-start",
                                                  marginLeft: "1rem",
                                                  marginTop: "5px",
                                                  alignItems: "center",
                                                  alignContent: "center",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    border:
                                                      "0px solid rgba(64,65,79,1)",
                                                    display: "flex",
                                                    gap: "1rem",
                                                    paddingLeft: "50px",
                                                    borderRadius: "6px",
                                                    paddingTop: "1rem",
                                                    paddingBottom: "1rem",
                                                  }}
                                                >
                                                  <div style={{ color: "#999" }}>
                                                    Is this response helpful so
                                                    far?
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      gap: "10px",
                                                      paddingLeft: "2rem",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "grid",
                                                        alignItems: "center",
                                                        alignContent: "center",
                                                      }}
                                                    >
                                                      <ThumbUpIcon
                                                        id={`like_${message.uiid}`}
                                                        className={`${
                                                          message.feedback === true
                                                            ? "goodfeedback"
                                                            : ""
                                                        }`}
                                                        onClick={() =>
                                                          feedbackAction(
                                                            message.uiid,
                                                            message.text,
                                                            "good",
                                                            message.question
                                                          )
                                                        }
                                                        sx={{
                                                          fontSize: "14px",
                                                          cursor: "pointer",
                                                          color: "#999",
                                                        }}
                                                      />
                                                    </span>
                                                    <span
                                                      style={{
                                                        display: "grid",
                                                        alignItems: "center",
                                                        alignContent: "center",
                                                      }}
                                                    >
                                                      <ThumbDownIcon
                                                        className={`${
                                                          message.feedback === false
                                                            ? "badFeedback"
                                                            : ""
                                                        }`}
                                                        id={`dislike_${message.uiid}`}
                                                        onClick={() =>
                                                          feedbackAction(
                                                            message.uiid,
                                                            message.text,
                                                            "bad",
                                                            message.question
                                                          )
                                                        }
                                                        sx={{
                                                          fontSize: "14px",
                                                          cursor: "pointer",
                                                          color: "#999",
                                                        }}
                                                      />
                                                    </span>

                                                    <span
                                                      style={{
                                                        display: "grid",
                                                        alignItems: "center",
                                                        alignContent: "center",
                                                      }}
                                                    >
                                                      <ContentCopyIcon
                                                        onClick={() =>
                                                          handleCopyClick({
                                                            index,
                                                          })
                                                        }
                                                        sx={{
                                                          fontSize: "14px",
                                                          cursor: "pointer",
                                                          color: "#999",
                                                        }}
                                                      />
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {isPdfView && (
                          
                                <PdfViewModal
                                  pdfUrl={pdfUrl}
                                  setPdfUrl={setPdfUrl}
                                  setIsPdfView={setIsPdfView}
                                />
                              )}
                            </div>
                          </>

                          {!diableChats && (
                            <>
                              <div
                                className="card-body border-top border-bottom"
                                id="textboxChats"
                              >
                                {summaryView && (
                                  <div className="">
                                    <div className="col-12 inputTextboxHome">
                                      <div className="input-group mt-0 mb-0">
                                        <input
                                          id="chat_pdf_input"
                                          placeholder="What is organic net growth of Mondelez?"
                                          className="message-type-box form-control border-0"
                                          type="text"
                                          value={userInput}
                                          onKeyDown={handleFollowupKeyDown}
                                          onChange={handleInputChange}
                                          autoComplete="off"
                                          onKeyPress={handleInputKeyPress}
                                        />

                                        <>
                                          <Button
                                            id="send_pdf_chat"
                                            className="btn btn-light-success text-success sendbtn borderColorNew"
                                            onClick={() =>
                                              handleSendMessage(
                                                "summary",
                                                "followup"
                                              )
                                            }
                                            disabled={
                                              loadingResponce || !userInput
                                            }
                                            title="Send"
                                          >
                                            {loadingResponce ? (
                                              <>
                                                <span
                                                  className="spinner-border spinner-border-sm"
                                                  role="status"
                                                  aria-hidden="true"
                                                ></span>
                                              </>
                                            ) : (
                                              <SendIcon className="colorCss" />
                                            )}
                                          </Button>
                                        </>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    </>
                  )}
                </>
              </div>
            </div>

            {/* // rating dialog box  */}
            <FeedbackModel
              open={open}
              Transition={Transition}
              handleclose={handleclose}
              Feedback={Feedback}
              iserror={iserror}
              selectedOptions={selectedOptions}
              handleButtonClick={handleButtonClick}
              handleSubmit={handleSubmit}
              validated={validated}
              setCommentData={setCommentData}
              CommentData={CommentData}
              isLoading={isLoading}
            />

            {/* // delete conversation dialog  */}
            <DeleteModel
              isdeletePopup={isdeletePopup}
              Transition={Transition}
              setisdeletePopup={setisdeletePopup}
              isdeleteLoading={isdeleteLoading}
              handleDelete={handleDelete}
              sessionId ={SessionIdData}          />

            {issuccess && (
              <div
                style={{
                  position: "absolute",
                  right: "20px",
                  bottom: "25px",
                  zIndex: "9999",
                }}
              >
                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                  Your feedback is submitted successfully
                </Alert>
              </div>
            )}

            {isalert && (
              <div
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "17%",
                  zIndex: "9999",
                }}
              >
                <Alert severity={errorType}>{errorMessage}</Alert>
              </div>
            )}
          </Box>
        </Box>
      </div>
    </AuthenticatedTemplate>

    <UnauthenticatedTemplate>
          <Login/>
    </UnauthenticatedTemplate>

    </>

  );
}
